import range from 'lodash-es/range';
import {
    BZ2_SELLER_SEARCH_LIKED_LABEL,
    BZ2_SELLER_SEARCH_MOVED,
    BZ2_SELLER_SEARCH_SHOW_MORE,
} from 'mk/autogenerated/translations/SellerSearch.e5a271a64dceb15597199097626cf7bd'
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import SellerCard, { SellerCardPlaceholder } from 'mk2/apps/bazaar/components/SellerCard';
import { ITEMS_PER_PAGE } from 'mk2/apps/bazaar/containers/SellerSearch/SellerSearch.constants';
import { Props } from 'mk2/apps/bazaar/containers/SellerSearch/SellerSearchPage';
import { Btn, BtnType } from 'mk2/components/Btn';
import { LineHeader } from 'mk2/components/LineHeader';
import { LoadingSwitch } from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { isLoading, LoadingState } from 'mk2/reducers/loadingState';
import React from 'react';
import styles from './SellerSearch.mscss';

class SellerSearch extends React.Component<Props> {

    public render() {
        const { loadingState, sellers, requestUser } = this.props;

        return (
            <div className={styles.SellerSearch}>
                <div
                    className={styles.SellerSearch__moved}
                    dangerouslySetInnerHTML={{__html: BZ2_SELLER_SEARCH_MOVED}}
                />

                {isAuthenticated(requestUser) && (
                    <div className={styles.SellerSearch__liked}>
                        <LineHeader
                            level={1}
                            heading={BZ2_SELLER_SEARCH_LIKED_LABEL}
                        />

                        <div className={styles.SellerSearch__results}>
                            <LoadingSwitch
                                loadingState={loadingState}
                                onLoad={this.load}
                                onRenderSuccess={this.renderSuccess}
                                onRenderInit={this.renderInit}
                                hasData={sellers && sellers.length > 0}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }

    private renderInit = () => {
        return (
            <>
                {range(6).map((index) => (
                    <SellerCardPlaceholder key={index} />
                ))}
            </>
        );
    };

    private renderSuccess = () => {
        const { sellers, loadingState, total } = this.props;
        return (
            <>
                {sellers.map((seller) => (
                    <SellerCard seller={seller} key={seller.id} />
                ))}
                {isLoading(loadingState) && (
                    range(Math.min(total - sellers.length, ITEMS_PER_PAGE)).map((index) => (
                        <SellerCardPlaceholder key={index} />
                    ))
                )}
                {!isLoading(loadingState) && total > sellers.length && (
                    <div className={styles.SellerSearch__pager}>
                        <Btn type={BtnType.BlueOutline} label={BZ2_SELLER_SEARCH_SHOW_MORE} onClick={this.loadNext} />
                    </div>
                )}
            </>
        );
    };

    private load = () => {
        this.props.onLoad(0);
    };

    private loadNext = () => {
        this.props.onLoad(this.props.sellers.length);
    };

}

export default SellerSearch;
